// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import '@/assets/reset.css'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
// import '@/assets/reset.css'
// import '@/public/rem.scss'

// import $ from 'jquery';
// import Zepto from '../../../static/zepto'
// import device from '../../../static/device'
// let unionlog = require("../../../static/unionlog")

Vue.use(MintUI)

// import {
//   downloadImgs
// } from "@/public/util.js";
// import { Indicator } from 'mint-ui';

// Indicator.open();
// downloadImgs(function(){
//   Indicator.close();
//   new Vue({
//     el: '#app',
//     components: { App },
//     template: '<App/>'
//   })
// });
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})
  




// WEBPACK FOOTER //
// ./src/pages/friend/friend.js